'use client';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { PriceCalculatorForm } from '../../homepage/price-calculator-form';
import { useResponsiveDialogStore } from '@eliadmin/core/src/components/ui/responsive-dialog';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export const PriceCalculatorButton = ({
  label,
  className,
}: {
  label: string;
  className?: { box?: string; button?: string };
}) => {
  const { t } = useTranslations();
  const { open } = useResponsiveDialogStore();

  const handleOpen = () => {
    open({
      id: PriceCalculatorForm.id,
      content: <PriceCalculatorForm />,
    });
  };

  return (
    <>
      <div className={cn(className?.box)}>
        <Button className={cn('whitespace-nowrap', className?.button)} onClick={() => handleOpen()}>
          {label ? label : t('text3905')}
        </Button>
      </div>
    </>
  );
};
